
'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');
//
require('./Audio.less');

function isPlaying(audelem) {
    return !audelem.paused;
}

// var HAVE_NOTHING = 0; // - no information whether or not the audio/video is ready
// var HAVE_METADATA = 1; // - metadata for the audio/video is ready
// var HAVE_CURRENT_DATA = 2; // - data for the current playback position is available,
//but not enough data to play next frame/millisecond
// var HAVE_FUTURE_DATA = 3; // - data for the current and at least the next frame is available
var HAVE_ENOUGH_DATA = 4; // - enough data available to start playing

module.exports = Backbone.View.extend({

    el: '.Audio',

    events: {
        'click .Audio-track': 'onTrackClick'
    },

    currentTrack: null,

    interval: null,

    initialize: function () {
        _.bindAll(this, 'autoplay', 'stopAll');

        // this.AudioImage = this.$('.Audio-image')[0];

        window.app.vent.on('audio.stopAll', this.stopAll);
    },

    stopAll: function () {
        var self = this;

        var tracks = this.$el.find('.Audio-track');
        var audios = this.$el.find('audio');

        tracks.toggleClass('Audio-track--playing', false);

        audios.each(function () {
            if (this.readyState === HAVE_ENOUGH_DATA) {
                this.pause();
                this.currentTime = 0;
                self.changeDuration(this);
            }
        });

        clearInterval(this.interval);
    },

    // calculateTotalValue: function (length) {
    //     var minutes = Math.floor(length / 60);
    //     var secondsInt = length - minutes * 60;
    //     var secondsStr = secondsInt.toString();
    //     var seconds = secondsStr.substr(0, 2);
    //     var time = minutes + ':' + seconds;

    //     return time;
    // },

    calculateCurrentValue: function (seconds) {
        var currentMinute = parseInt(seconds / 60, 10) % 60;
        var currentSecondsLong = seconds % 60;
        var currentSeconds = currentSecondsLong.toFixed();
        var currentTime = (currentMinute < 10 ? '0' + currentMinute : currentMinute) + ':'
            + (currentSeconds < 10 ? '0' + currentSeconds : currentSeconds);

        return currentTime;
    },

    changeDuration: function (player) {
        var timeLeft = player.duration - player.currentTime;
        var formattedTime = this.calculateCurrentValue(timeLeft);
        var percentProgress = (player.currentTime / player.duration * 100).toFixed(2);

        var $track = $(player).closest('.Audio-track');

        $track.find('.Audio-duration').html(formattedTime);
        $track.find('.Audio-progressBar').css({
            'clip-path': `polygon(0 0, ${percentProgress}% 0, ${percentProgress}% 100%, 0 100%)`,
            '-webkit-clip-path': `polygon(0 0, ${percentProgress}% 0, ${percentProgress}% 100%, 0 100%)`
        });
    },

    startInterval: function (player) {
        var self = this;

        this.changeDuration(player);

        this.interval = setInterval(function () {
            self.changeDuration(player);
        }, 100);
    },

    onTrackClick: function (e) {
        var $target = this.$(e.currentTarget);
        var player = $target.find('audio').get(0);
        var id = $target.data('id');

        if (this.currentTrack !== id) {
            this.stopAll();
        }

        if (isPlaying(player)) {
            // this.currentTrack = null;
            player.pause();
            $target.toggleClass('Audio-track--playing', false);

            clearInterval(this.interval);
        } else {
            app.vent.trigger('IndexTitle.stop'); //выключение пасхалки в тайтле
            this.currentTrack = id;
            player.play();
            $target.toggleClass('Audio-track--playing', true);

            player.onended = this.autoplay;

            this.startInterval(player);
        }

        console.log('this.currentTrack', this.currentTrack);
    },

    autoplay: function () {
        this.stopAll();

        var $nextTrack = this.$(`.Audio-track[data-id="${this.currentTrack + 1}"]`);

        if ($nextTrack) {
            var player = $nextTrack.find('audio').get(0);
            player.play();
            player.onended = this.autoplay;
            this.currentTrack += 1;
            $nextTrack.toggleClass('Audio-track--playing', true);

            clearInterval(this.interval);
            this.startInterval(player);
        }
    }
});


